// extracted by mini-css-extract-plugin
export default {"root":"ReportSettings_root__gieYJ","labelTab":"ReportSettings_labelTab__8eeCp","tabs":"ReportSettings_tabs__Y0w3H","wrapper":"ReportSettings_wrapper__zuBBd"};